module.exports = __webpack_public_path__ + "media/images/destination-b6a5f1dd65ce89d35fae68abf0ee8373.png";